import React, { useEffect, useState } from "react";

/** A cached page import that also renders synchronously after server preload. */
export default function createRoutePage(loader) {
  let Component;
  let failure;
  let pending;
  function preload() {
    if (!pending) {
      pending = Promise.resolve().then(loader).then((module) => {
        if (!module.default) throw new Error("The requested page has no component.");
        Component = module.default;
      }).catch((error) => {
        failure = error;
        throw error;
      });
    }
    return pending;
  }
  function RoutePage(props) {
    const [, update] = useState(0);
    useEffect(() => {
      if (Component) return undefined;
      let mounted = true;
      const settle = () => { if (mounted) update((value) => value + 1); };
      preload().then(settle, settle);
      return () => { mounted = false; };
    }, []);
    if (failure) throw failure;
    if (Component) return <Component {...props} />;
    return <div className="maximumWidth panel" role="status" aria-live="polite">Loading page…</div>;
  }
  RoutePage.preload = preload;
  return RoutePage;
}
